import { render, staticRenderFns } from "./CampaignAuth.vue?vue&type=template&id=2fbdfa05&scoped=true&"
import script from "./CampaignAuth.vue?vue&type=script&lang=js&"
export * from "./CampaignAuth.vue?vue&type=script&lang=js&"
import style0 from "./CampaignAuth.vue?vue&type=style&index=0&id=2fbdfa05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbdfa05",
  null
  
)

export default component.exports